<template lang="pug">
    div.weaponContent(v-if="weaponItem && JSON.stringify(weaponItem)!=='{}'")
        div.weaponIconBox
            div.weaponClassIcon
                img(alt="", :src="require('../assets/weapon_class_icon/'+weaponItem.weaponClassIcon)")
            div.weaponIcon
                img(alt="", :src="require('../assets/weapon_icon/'+weaponItem.weaponIcon)")
        div.weaponIntroduction
            div.content
                span.weaponName {{weaponItem.weaponName}}
                span.weaponClassName {{weaponItem.weaponClassName}}
                span.weaponDescribe {{weaponItem.weaponDescribe}}
        div.weaponBasic
            div.content
                span.contentTitle {{$t("weaponContent.weaponBasicTitle")}}
                div(v-if="weaponItem.weaponBasic.ballisticSkills != '' && weaponItem.weaponBasic.ballisticSkills != '-' && weaponItem.weaponBasic.ballisticSkills != '0'")
                    span.left {{$t("weaponContent.ballisticSkills")}}
                    span.right {{weaponItem.weaponBasic.ballisticSkills}}
                div(v-if="weaponItem.weaponBasic.penetrationSkill != '' && weaponItem.weaponBasic.penetrationSkill != '-' && weaponItem.weaponBasic.penetrationSkill != '0'")
                    span.left {{$t("weaponContent.penetrationSkill")}}
                    span.right {{weaponItem.weaponBasic.penetrationSkill}}
                div(v-if="weaponItem.weaponBasic.cooling != '' && weaponItem.weaponBasic.cooling != '-' && weaponItem.weaponBasic.cooling != '0'")
                    span.left {{$t("weaponContent.cooling")}}
                    span.right {{weaponItem.weaponBasic.cooling}}
                div(v-if="weaponItem.weaponBasic.hurt != '' && weaponItem.weaponBasic.hurt != '-' && weaponItem.weaponBasic.hurt != '0'")
                    span.left {{$t("weaponContent.hurt")}}
                    span.right {{weaponItem.weaponBasic.hurt}}
                div(v-if="weaponItem.weaponBasic.toHit != '' && weaponItem.weaponBasic.toHit != '-' && weaponItem.weaponBasic.toHit != '0'")
                    span.left {{$t("weaponContent.toHit")}}
                    span.right {{weaponItem.weaponBasic.toHit}}
                div(v-if="weaponItem.weaponBasic.blast != '' && weaponItem.weaponBasic.blast != '-' && weaponItem.weaponBasic.blast != '0'")
                    span.left {{$t("weaponContent.blast")}}
                    span.right {{weaponItem.weaponBasic.blast}}
                div(v-if="weaponItem.weaponBasic.directHit != '' && weaponItem.weaponBasic.directHit != '-' && weaponItem.weaponBasic.directHit != '0'")
                    span.left {{$t("weaponContent.directHit")}}
                    span.right {{weaponItem.weaponBasic.directHit}}
                div(v-if="weaponItem.weaponBasic.sputtering != '' && weaponItem.weaponBasic.sputtering != '-' && weaponItem.weaponBasic.sputtering != '0'")
                    span.left {{$t("weaponContent.sputtering")}}
                    span.right {{weaponItem.weaponBasic.sputtering}}
                div(v-if="weaponItem.weaponBasic.freezingField != '' && weaponItem.weaponBasic.freezingField != '-' && weaponItem.weaponBasic.freezingField != '0'")
                    span.left {{$t("weaponContent.freezingField")}}
                    span.right {{weaponItem.weaponBasic.freezingField}}
                div(v-if="weaponItem.weaponBasic.pierceThrough != '' && weaponItem.weaponBasic.pierceThrough != '-' && weaponItem.weaponBasic.pierceThrough != '0'")
                    span.left {{$t("weaponContent.pierceThrough")}}
                    span.right {{weaponItem.weaponBasic.pierceThrough}}
                div(v-if="weaponItem.weaponBasic.injuryInterval != '' && weaponItem.weaponBasic.injuryInterval != '-' && weaponItem.weaponBasic.injuryInterval != '0'")
                    span.left {{$t("weaponContent.injuryInterval")}}
                    span.right {{weaponItem.weaponBasic.injuryInterval}}
                div(v-if="weaponItem.weaponBasic.freezingFieldInjuryInterval != '' && weaponItem.weaponBasic.freezingFieldInjuryInterval != '-' && weaponItem.weaponBasic.freezingFieldInjuryInterval != '0'")
                    span.left {{$t("weaponContent.freezingFieldInjuryInterval")}}
                    span.right {{weaponItem.weaponBasic.freezingFieldInjuryInterval}}
                div(v-if="weaponItem.weaponBasic.duration != '' && weaponItem.weaponBasic.duration != '-' && weaponItem.weaponBasic.duration != '0'")
                    span.left {{$t("weaponContent.duration")}}
                    span.right {{weaponItem.weaponBasic.duration}}
                div(v-if="weaponItem.weaponBasic.freezingFieldDuration != '' && weaponItem.weaponBasic.freezingFieldDuration != '-' && weaponItem.weaponBasic.freezingFieldDuration != '0'")
                    span.left {{$t("weaponContent.freezingFieldDuration")}}
                    span.right {{weaponItem.weaponBasic.freezingFieldDuration}}
                div(v-if="weaponItem.weaponBasic.damageScope != '' && weaponItem.weaponBasic.damageScope != '-' && weaponItem.weaponBasic.damageScope != '0'")
                    span.left {{$t("weaponContent.damageScope")}}
                    span.right {{weaponItem.weaponBasic.damageScope}}
                div(v-if="weaponItem.weaponBasic.numberOfCatapults != '' && weaponItem.weaponBasic.numberOfCatapults != '-' && weaponItem.weaponBasic.numberOfCatapults != '0'")
                    span.left {{$t("weaponContent.numberOfCatapults")}}
                    span.right {{weaponItem.weaponBasic.numberOfCatapults}}
                div.over
        div.weaponLevel
            div.content
                span.contentTitle {{$t("weaponContent.weaponLevelTitle")}}
                div#weaponLevelInfo
                    div(v-for="(item, index) in weaponItem.weaponLevel", :key="index", class="weaponLevelItem")
                        div#weaponLevelItemLevel {{$t("common.level")}}.{{weaponItem.weaponLevel[index].level}}
                        div#weaponLevelItemRight
                            div(v-if="weaponItem.weaponLevel[index].atk != '' && weaponItem.weaponLevel[index].atk != '-' && weaponItem.weaponLevel[index].atk != '0'") ATK+{{weaponItem.weaponLevel[index].atk}}
                            div(v-if="weaponItem.weaponLevel[index].attribute1 != '' && weaponItem.weaponLevel[index].attribute1 != '-' && weaponItem.weaponLevel[index].attribute1 != '0'") {{weaponItem.weaponLevel[index].attribute1}}
                            div(v-if="weaponItem.weaponLevel[index].attribute2 != '' && weaponItem.weaponLevel[index].attribute2 != '-' && weaponItem.weaponLevel[index].attribute2 != '0'") {{weaponItem.weaponLevel[index].attribute2}}
                            div(v-if="weaponItem.weaponLevel[index].describe != '' && weaponItem.weaponLevel[index].describe != '-' && weaponItem.weaponLevel[index].describe != '0'") {{weaponItem.weaponLevel[index].describe}}
        div.weaponPerk
            div.content
                span.contentTitle {{$t("weaponContent.weaponPerkTitle")}}
                div#weaponPerkInfo
                    div(v-for="(item, index) in weaponItem.weaponPerk", :key="index", class="weaponPerkItem")
                        div(v-if="weaponItem.weaponPerk[index].parkName != '' && weaponItem.weaponPerk[index].parkName != '-' && weaponItem.weaponPerk[index].parkName != '0'")
                            span.left {{$t("weaponContent.parkName")}}
                            span.right {{weaponItem.weaponPerk[index].parkName}}
                        div(v-if="weaponItem.weaponPerk[index].parkDescribe != '' && weaponItem.weaponPerk[index].parkDescribe != '-' && weaponItem.weaponPerk[index].parkDescribe != '0'")
                            span.left {{$t("weaponContent.parkDescribe")}}
                            span.right {{weaponItem.weaponPerk[index].parkDescribe}}
                        div(v-if="weaponItem.weaponPerk[index].preconditions != '' && weaponItem.weaponPerk[index].preconditions != '-' && weaponItem.weaponPerk[index].preconditions != '0'")
                            span.left {{$t("weaponContent.preconditions")}}
                            span.right {{weaponItem.weaponPerk[index].preconditions}}
                        div(v-if="weaponItem.weaponPerk[index].mutualExclusion != '' && weaponItem.weaponPerk[index].mutualExclusion != '-' && weaponItem.weaponPerk[index].mutualExclusion != '0'") 
                            span.left {{$t("weaponContent.mutualExclusion")}}
                            span.right {{weaponItem.weaponPerk[index].mutualExclusion}}
</template>
  
<script>
export default {
    name: 'WeaponContent',
    data() {
        return {
            weaponId:"",
            weaponItem:{},
            weaponItemList:[]
        }
    },
    created() {
        
    },
    methods:{
        retrieveData(){
            for(let i = 0; i < this.weaponItemList.length; i++){
                if(this.weaponItemList[i].weaponId == this.weaponId){
                    this.weaponItem = this.$t("weaponItemList["+i+"]")
                }
            }
        }
    },
    components:{

    },
    mounted() {
        let wikiData = require("../assets/lang/zh_CN.json");
        this.weaponItem = {}
        this.weaponItemList = []
        this.weaponItemList = wikiData.weaponItemList,
        this.weaponId = this.$route.params.id
        this.$nextTick(() => {
            this.retrieveData()
        })
    }
}
</script>

<style lang="scss">
#app{
    background-color: #1c1f1f;
    background: url("../assets/foot_bg.png") center bottom no-repeat;
    background-size: contain;
}
.weaponContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    background: url("../assets/weapon_icon_bg.png") center top no-repeat;
    background-size: contain;
    .weaponIconBox {
        margin: 25px 0;
        position: relative;
        width: 172.9px;
        height: 210px;
        background: url("../assets/weapon_icon_box_bg.png") center top no-repeat;
        background-size: cover;
    }
    .weaponClassIcon {
        padding: 11.82px 0 0 29.76px;
        width: 27.7px;
        height: 38.6px;
    }
    .weaponClassIcon img {
        width: 100%;
        height: 100%;
    }
    .weaponIcon {
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 97.28px;
        height: 142.8px;
    }
    .weaponIcon img {
        width: 100%;
        height: 100%;
    }
    .weaponIntroduction {
        margin-top: 22px;
        width: 90%;
        color: #dceae3;
    }
    .weaponBasic {
        margin-top: 22px;
        width: 90%;
        color: #dceae3;
    }
    .weaponLevel {
        margin-top: 22px;
        width: 90%;
        color: #dceae3;
    }
    .weaponPerk {
        margin: 22px 0;
        width: 90%;
        color: #dceae3;
    }
    .content {
        float: left;
        width: 100%;
        min-height: 124px;
        background: url("../assets/content_bg.png") top center no-repeat;
        background-size: contain;
        background-color: rgba(0,0,0,0.7);
        border: 1px #212322 solid;
    }
    .contentTitle {
        float: left;
        margin: 15px 0;
        padding-left: 8%;
        width: 92%;
        font-size: 20px;
        line-height: 18px;
        background: url("../assets/title_icon.png") 5% center no-repeat;
        background-size: contain;
    }
    .content div {
        float: left;
        margin: 0 0 0 5%;
        width: 90%;
        border-top: 2px #262a27 solid;
    }
    .content .over {
        float: left;
        padding-top: 20px;
        margin: 0 5%;
        width: 90%;
        border-top: 2px #262a27 solid;
    }
    .content .left {
        float: left;
        padding: 5px 0 5px 5%;
        width: 60%;
        font-size: 14px;
        text-align: left;
        color: #dceae3;
    }
    .content .right {
        float: left;
        padding: 5px 5% 5px 0;
        width: 30%;
        font-size: 14px;
        text-align: right;
        color: #dceae3;
    }
    .weaponName {
        float: left;
        margin-top: 5px;
        padding: 0 5%;
        width: 90%;
        font-size: 32px;
    }
    .weaponClassName {
        float: left;
        margin-bottom: 5px;
        padding: 0 5%;
        width: 90%;
        font-size: 20px;
    }
    .weaponDescribe {
        float: left;
        margin-bottom: 10px;
        padding: 0 5%;
        width: 90%;
        font-size: 14px;
    }
    #weaponLevelInfo {
        margin: 0 0 10px 0;
        width: 100%;
        height: 300px;
        border: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .weaponLevelItem {
        position: relative;
    }
    .weaponLevelItem:last-child {
        border-bottom: 2px #262a27 solid;
    }
    #weaponLevelItemLevel {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: 0;
        width: 20%;
        height: 100%;
        font-size: 14px;
        justify-content: left;
        align-items: center;
        border: none;
        display: flex;
        text-indent: 5px;
    }
    #weaponLevelItemRight {
        float: right;
        margin: 0;
        width: 79%;
        border-left: 1px #262a27 solid;
        border-top: none;
    }
    #weaponLevelItemRight div {
        margin: 0;
        padding: 5px 5%;
        width: 90%;
        text-align: left;
        border-top: none;
        border-bottom: 1px #262a27 solid;
    }
    #weaponLevelItemRight div:last-child {
        border-bottom: none;
    }
    #weaponPerkInfo {
        margin: 0 0 10px 0;
        width: 100%;
        border: 0;
    }
    .weaponPerkItem {
        border-top: none !important;
        margin-bottom: 15px !important;
        //padding-bottom: 15px;
        background: url("../assets/weapon_perk_item_bg.png") no-repeat;
        background-position: center;
        background-size: 100% 100%;
    }
    .weaponPerkItem div {
        margin: 0;
        width: 100%;
        height: 100%;
        border-top: 1px #262a27 solid;
        display: flex;
        align-items: stretch;
        flex-direction: row;
    }
    .weaponPerkItem div:first-child {
        border: 0;
    }
    .weaponPerkItem div .left {
        justify-content: left;
        align-items: center;
        display: flex;
        padding: 5px 5px;
        width: 35%;
        text-align: left;
        background-color: rgba(46, 50, 47, 0.7);
    }
    .weaponPerkItem div .right {
        padding: 5px 5px;
        width: 64%;
        text-align: left;
        border-left: 1px #262a27 solid;
        background-color: rgba(22, 23, 22, 0.7);
    }
    span {
        white-space: pre-wrap;
    }
}
</style>